import { useNavigate, useParams } from 'react-router-dom'
import {
	FormValues,
	GroupForm,
} from '@/modules/manage-member/components/GroupForm'
import useMutationUpdateGroup from '@/modules/manage-member/api/hooks/useMutateUpdateGroup'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useRef } from 'react'
import { UseFormReturn } from 'react-hook-form'
import useQueryGetGroupById from '@/modules/manage-member/api/hooks/useQueryGetGroupById'
import Spinner from '@/common/components/Spinner'
import { useQueryClient } from '@tanstack/react-query'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

interface EditGroupFormProps {
	defaultValues?: Partial<FormValues>
}

export function EditGroupForm({ defaultValues }: EditGroupFormProps) {
	const { id } = useParams()
	const { data: group, isLoading } = useQueryGetGroupById(id!)
	const { mutate: updateGroup } = useMutationUpdateGroup()
	const navigate = useNavigate()
	const formRef = useRef<UseFormReturn<FormValues>>(null)
	const queryClient = useQueryClient()

	if (isLoading || !group) return <Spinner />

	const handleSubmit = (
		values: FormValues,
		form: UseFormReturn<FormValues>,
	) => {
		try {
			updateGroup(
				{
					id: id!,
					payload: {
						name: values.name,
						writePermission: values.writePermission as any,
						readPermission: values.readPermission as any,
					},
				},
				{
					onSuccess: () => {
						toast.success('แก้ไขกลุ่มผู้ใช้งานเรียบร้อย')
						queryClient.invalidateQueries({
							queryKey: [OperatorQueryKeys.GetGroupById, id],
						})
						navigate(-1)
					},
					onError: (error: any) => {
						const errorMessage = error?.response?.data?.message
						if (errorMessage === 'DUPLICATE_GROUP_NAME') {
							form.setError('name', {
								message: 'ชื่อกลุ่มนี้มีการใช้งานแล้ว',
							})
							return
						}
						showErrorToast('ไม่สามารถสร้างกลุ่มผู้ใช้งานได้')
					},
				},
			)
		} catch (error) {
			showErrorToast(error as Error)
		}
	}

	const mergedDefaultValues = {
		...defaultValues,
		...(group && {
			name: group.name,
			writePermission: group.writePermission as FormValues['writePermission'],
			readPermission: group.readPermission as FormValues['readPermission'],
		}),
	}

	return (
		<GroupForm
			formRef={formRef}
			defaultValues={mergedDefaultValues}
			onSubmit={handleSubmit}
			submitText="บันทึก"
		/>
	)
}
